export class ReqForgetPassword {
    email?: string;
    phoneNumber?: string;
}

export class ForgetPasswordModel {
    email?: string;
    phoneNumber?: string;
    code!: string;
    password!: string;
    confirmPassword!: string;
}